import { useState } from "react";
import patient from "../../../../assets/img/patient.jpg";
import rightArrow from "../../../../assets/img/arrow-right.svg";
import upload_icon from "../../../../assets/img/upload_icoon.svg";
import { useNavigate } from "react-router";
import { showToast, ToastContainer } from "../../../../util/toastHelper";
import { ADMIN_CMS_TESTIMONIALS } from "../../../../action/apiPath";
import { createShortNameFile, errorMessageCreate } from "../../../../util/custom";
import { ADMIN_CMS_TESTIMONIALS_IMAGE_UPLOAD_AWS } from "../../../../action/apiPath";
import { ADMINCMSTESTIMONIALPAGE } from "../../../../util/path";
import Loading from "react-fullscreen-loading";
import { CallWithAuth } from "../../../../action/apiActions";

const AdminTestimonialAdd = () => {
    const navigate = useNavigate()
    const [testimonial, setTestimonial] = useState({
        quote: "",
        author_name: "",
        author_title: "",
        author_image: ""
    });

    const [isLoading, setIsLoading] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name == "author_name") {
            let _value = value.replace(/[^a-zA-Z\s]/g, '');
            setTestimonial({ ...testimonial, [name]: _value });
        } else {
            setTestimonial({ ...testimonial, [name]: value });
        }
    };

    const handleSubmit = async () => {
        if (!testimonial.quote) {
            showToast("error", "Quote is required.");
            return;
        }

        if (!testimonial.author_name) {
            showToast("error", "Name is required.");
            return;
        }

        const regex = /^[A-Za-z\s]*$/;
        if (!regex.test(testimonial.author_name)) {
            showToast("error", "Name must contains only letters & spaces");
            return;
        }

        if (!testimonial.author_title) {
            showToast("error", "Designation is required.");
            return;
        }

        if (!testimonial.author_image) {
            showToast("error", "Please upload the author's image.");
            return;
        }

        try {
            setIsSubmit(true);

            let response = await CallWithAuth("POST", ADMIN_CMS_TESTIMONIALS, testimonial);

            let message = errorMessageCreate(response?.res?.data?.message);
            if (response?.res?.data?.statusCode === 201) {
                showToast("success", message);
                setTimeout(() => {
                    navigate(`${ADMINCMSTESTIMONIALPAGE}`);
                    setIsSubmit(false);

                }, 1000);

            } else {
                let message = errorMessageCreate(response?.res?.data?.message);
                showToast("error", message);
                setIsSubmit(false);
            }
        } catch (err) {
            console.log(err);
            setIsSubmit(false);
        }
    };


    const handleDropTestimonialImageFrom = async (e) => {
        e.preventDefault();
        try {
            setIsLoading(true);
            const files = e.dataTransfer.files;
            const file = files[0];

            const formdata = new FormData();
            formdata.append("file", file);
            const body = formdata;
            const response = await CallWithAuth("POST", ADMIN_CMS_TESTIMONIALS_IMAGE_UPLOAD_AWS, body);
            let message = errorMessageCreate("Something went wrong!");

            if (response?.res?.status === 200 || response?.res?.status === 201) {
                showToast("success", "Patient's facial image selected successfully.");
                setTestimonial(prevData => ({
                    ...prevData,
                    author_image: response?.res?.data?.file_url
                }));
            } else {
                showToast("error", message);
            }
        } catch (err) {
            const message = err?.response?.data?.message || err?.message || "Image upload failed. Please try again.";
            showToast("error", message);
        } finally {
            setIsLoading(false);
        }
    };

    const handleChangeTestimonialImageFile = async (e) => {
        setIsLoading(true);

        try {
            const { files } = e.target;
            const file = files[0];
            const formdata = new FormData();
            formdata.append("file", file);
            const body = formdata;
            const response = await CallWithAuth("POST", ADMIN_CMS_TESTIMONIALS_IMAGE_UPLOAD_AWS, body);
            let message = errorMessageCreate("Something went wrong!");

            if (response?.res?.status === 200 || 201) {
                showToast("success", "Testimonial facial image selected successfully.");
                setTestimonial(prevData => ({
                    ...prevData,
                    author_image: response?.res?.data?.file_url
                }));
            } else {
                showToast("error", message);
            }
        } catch (err) {
            const message = err?.response?.data?.message || err?.message || "Image upload failed. Please try again.";
            showToast("error", message);
        } finally {
            setIsLoading(false);
        }
    }

    return (
        <div>
            {isLoading && (<Loading loading background="rgba(236, 240, 241, 0.7)" loaderColor="#3498db" />)}

            <section class="site_hero patient_management_banner">
                <div class="site_container">
                    <div class="site_row">
                        <div class="txt_colm">
                            <div class="txt_block">
                                <h1>Manage Testimonial</h1>
                                <p>Manage each Testimonials efficiently</p>
                            </div>
                        </div>
                        <div class="img_colm">
                            <div class="img_block">
                                <img src={patient} alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="mycustomclass patient_form_block">
                <div class="site_container">
                    <div class="patient_form">
                        <div className="field_block">
                            <label htmlFor="quote">Quote*</label>
                            <input
                                type="text"
                                name="quote"
                                className="text_field"
                                placeholder="Enter Quote"
                                value={testimonial.quote}
                                onChange={handleInputChange}
                            />
                        </div>

                        <div className="field_block">
                            <label htmlFor="author_name">Name*</label>
                            <input
                                type="text"
                                name="author_name"
                                className="text_field"
                                placeholder="Enter Name"
                                value={testimonial.author_name}
                                onChange={handleInputChange}
                            />
                        </div>

                        <div className="field_block">
                            <label htmlFor="author_title">Designation*</label>
                            <input
                                type="text"
                                name="author_title"
                                className="text_field"
                                placeholder="Enter Designation"
                                value={testimonial.author_title}
                                onChange={handleInputChange}
                            />
                        </div>

                        <div
                            className="field_block col-md-6"
                            onDrop={(e) => handleDropTestimonialImageFrom(e)}
                            onDragOver={(e) => e.preventDefault()}
                        >
                            <div className="upload_field">
                                <div className="title">
                                    <label>Please upload the facial image</label>{" "}
                                </div>

                                <div className="upload_ui">
                                    <label className="upload_ui_label">
                                        <input
                                            type="file"
                                            name="author_image"
                                            accept=".png, .jpg, .jpeg"  // Only allow image files
                                            onChange={handleChangeTestimonialImageFile}
                                            style={{ display: "none" }} // Hide input element
                                        />
                                        <div className="ui_inner">
                                            <img src={upload_icon} alt="Upload" />
                                            <h5>Upload</h5>
                                            <p>
                                                <span>Browse</span> to upload the file
                                            </p>
                                        </div>
                                    </label>
                                </div>
                                {testimonial.author_image && testimonial.author_image != '' && (
                                    <>
                                        <div className="record_seesion_info">
                                            <p className="sm_txt">
                                                <strong>{createShortNameFile(testimonial.author_image)}</strong>
                                            </p>
                                            <a
                                                href={`${testimonial.author_image}`} // Full URL for S3 file
                                                target="_blank" // Opens link in a new tab
                                                rel="noopener noreferrer" // Security best practice
                                                className="edit"
                                            >
                                                <i className="fa-solid fa-eye"></i>
                                            </a>
                                        </div>
                                    </>
                                )}

                            </div>
                        </div>

                        <div className="field_block">
                            <div className="btn_row">
                                <button disabled={isLoading || isSubmit} onClick={handleSubmit}>
                                    <span>Submit </span> <img src={rightArrow} alt="Arrow" />
                                    {isSubmit && (
                                        <>
                                            {""}
                                            <span
                                                className="spinner-border spinner-border-sm"
                                                role="status"
                                                aria-hidden="true"
                                            ></span>
                                        </>
                                    )}
                                </button>
                            </div>
                        </div>


                    </div>
                </div>
            </section>
            <ToastContainer />

        </div>
    );
};

export default AdminTestimonialAdd;
